export default
    {
        // url: this.$store.state.http.hospital.YYYY,
        imprimeDocumentos: "/hospital/imprimeDocumentos",
        actualizaCama: "/movimientos/actualizaCama3",
        creaInter: "/movimientos/createV2",
        datosIner: "/movimientos/datosInternamiento",
        encamados: "/movimientos/encamados2",

        guardaItemConsumo: "/hospital/guardaItemConsumo",
        listItemsHojaConsumo: "/hospital/listItemsHojaConsumo",
        listHojaConsumo: "/hospital/listHojaConsumo",
        imprimeHojaConsumo: "/hospital/imprimeHojaConsumo",
        borraItemConsumo: "/hospital/borraItemConsumo",

        guardaCatItemConsumo: "/hospital/guardaCatItemConsumo",

        movimientoDiario:"/movimientos/movimientoDiario",
        imprimeMovimientoDiario:'/movimientos/imprimeMovimientoDiario',
    }
